"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var styles_1 = require("../../styles");
var react_2 = require("react");
var NEXT_PUBLIC_HOSTNAME_CLIENT = process.env.NEXT_PUBLIC_HOSTNAME_CLIENT;
var Translations = {
    'it': {
        'Home': 'Home',
        'Tienda': 'Negozio',
        'Mis habituales': 'Il solito',
        'Packs': 'Packs',
    },
    'es': {
        'Home': 'Home',
        'Tienda': 'Tienda',
        'Mis habituales': 'Mis habituales',
        'Packs': 'Packs',
    },
    'en': {
        'Home': 'Home',
        'Tienda': 'Shop',
        'Mis habituales': 'My Favourites',
        'Packs': 'Packs',
    },
    'fr': {
        'Home': 'Accueil',
        'Tienda': 'Boutique',
        'Mis habituales': 'Mon historique',
        'Packs': 'Packs',
    },
};
var Ul = (0, styled_components_1.default)(framer_motion_1.motion.ul)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n  grid-column: 1 / span 3;\n\n  ", "\n\n  button,\n  a {\n    display: inline-block;\n    font-family: ", ";\n    padding-bottom: 4px;\n    color: ", ";\n\n    ", "\n\n    > span {\n      right: ", ";\n      max-width: calc(100% - ", ");\n    }\n  }\n"], ["\n  display: none;\n  grid-column: 1 / span 3;\n\n  ", "\n\n  button,\n  a {\n    display: inline-block;\n    font-family: ", ";\n    padding-bottom: 4px;\n    color: ", ";\n\n    ", "\n\n    > span {\n      right: ", ";\n      max-width: calc(100% - ", ");\n    }\n  }\n"])), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    grid-column: 4 / span 3;\n  "], ["\n    display: flex;\n    grid-column: 4 / span 3;\n  "]))), function (_a) {
    var theme = _a.theme;
    return theme.fonts.platform;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greenlight;
}, styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-weight: bold;\n      padding: 0 ", ";\n      position: relative;\n      ", "\n    "], ["\n      font-weight: bold;\n      padding: 0 ", ";\n      position: relative;\n      ", "\n    "])), (0, styles_1.getRelative)(15, 'desktop'), (0, styles_1.createUnderline)({ height: 2, color: 'greenlight' })), (0, styles_1.getRelative)(30, 'desktop'), (0, styles_1.getRelative)(30, 'desktop'));
var getListItems = function (links, pathname, menuMobile, increaseLevel, url, theresPacks, firstCategory) {
    if (theresPacks === void 0) { theresPacks = false; }
    var Links = [];
    var locale = getCookies('NEXT_LOCALE') || 'es';
    for (var idx = 0; idx < links.length; idx++) {
        var linkData = links[idx];
        var name_1 = linkData.name, slug = linkData.slug;
        var isShopLink = slug === '/shop';
        var _name = Translations[locale][name_1];
        if (!theresPacks && name_1 === 'Packs')
            continue;
        Links.push((0, jsx_runtime_1.jsx)("li", { children: menuMobile && isShopLink ?
                (0, jsx_runtime_1.jsx)("a", __assign({ href: isShopLink && firstCategory ? url + "/shop/".concat(firstCategory.slug[locale]) : url + slug, className: pathname.includes(slug) ? 'active' : '' }, { children: _name }))
                :
                    (0, jsx_runtime_1.jsxs)("a", __assign({ href: isShopLink && firstCategory ? url + "/shop/".concat(firstCategory.slug[locale]) : url + slug, className: pathname.includes(slug) ? 'active' : '' }, { children: [_name, (0, jsx_runtime_1.jsx)("span", {})] })) }, idx));
    }
    return Links;
};
var getCookies = function (name) {
    var e_1, _a;
    var nameEQ = "".concat(name, "=");
    if (typeof window === 'undefined')
        return null;
    var arrayOfCookies = document.cookie.split(';');
    try {
        for (var arrayOfCookies_1 = __values(arrayOfCookies), arrayOfCookies_1_1 = arrayOfCookies_1.next(); !arrayOfCookies_1_1.done; arrayOfCookies_1_1 = arrayOfCookies_1.next()) {
            var rawCookie = arrayOfCookies_1_1.value;
            var cookie = rawCookie;
            while (cookie.charAt(0) == ' ')
                cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) == 0)
                return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arrayOfCookies_1_1 && !arrayOfCookies_1_1.done && (_a = arrayOfCookies_1.return)) _a.call(arrayOfCookies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
};
var fakeList = [{ name: 'Tienda', slug: '/shop' }, { name: 'Mis habituales', slug: '/account/usual-purchases' }, { name: 'Packs', slug: '/packs' }];
var NEXT_LOCALE = getCookies('NEXT_LOCALE') || 'es';
var hostname = {
    'es': 'hellomamma.es',
    'en': 'hellomamma.co.uk',
    'fr': 'hellomamma.fr'
};
var url = 'https://' + hostname[NEXT_LOCALE];
exports.NavList = (0, react_1.memo)(function (_a) {
    var _b = _a.firstCategory, firstCategory = _b === void 0 ? null : _b, theresPacks = _a.theresPacks, _c = _a.footer, footer = _c === void 0 ? false : _c, _d = _a.menuMobile, menuMobile = _d === void 0 ? false : _d, _e = _a.increaseLevel, increaseLevel = _e === void 0 ? null : _e;
    var _f = __read((0, react_2.useState)(getListItems(fakeList, 'bigcommerce', menuMobile, increaseLevel, undefined, undefined, firstCategory)), 2), ListItems = _f[0], setItems = _f[1];
    // const NEXT_REGION = getCookies('NEXT_REGION') || 'ES'
    var pathname = (0, react_1.useMemo)(function () {
        return 'bigcommerce';
    }, []);
    (0, react_2.useEffect)(function () {
        setItems(getListItems(fakeList, 'bigcommerce', menuMobile, increaseLevel, url, theresPacks, firstCategory));
    }, [NEXT_LOCALE]);
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, __assign({ exitBeforeEnter: true }, { children: (0, jsx_runtime_1.jsxs)(Ul, __assign({ className: 'nav-list', initial: 'inactive', animate: 'active', exit: 'exit' }, { children: [(footer || menuMobile) && (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: '/', className: pathname === '/' ? 'active' : '' }, { children: Translations[NEXT_LOCALE].Home })) }), ListItems] })) })));
});
var templateObject_1, templateObject_2, templateObject_3;
